import { NgModule } from "@angular/core";
import { ProjectRegisterValidationModule } from "./project/project-register-validation.module";

@NgModule({
  imports: [
    ProjectRegisterValidationModule,
  ]
})
export class ProjectsRepositoryProjectRegisterValidationModule {}
